import { Typography } from "@mui/material"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import Grid from "@mui/material/Grid"
import { styled } from "@mui/material/styles"
import ClpButton from "components/Button"
import { useTranslation } from "react-i18next"
import { useState } from "react"

const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  width: "100%",
  padding: theme.spacing(3),
  display: "flex",
  maxWidth: "100%",
  justifyContent: "space-between"
}))

const StyledBox = styled(DialogActions)(({ theme }) => ({
  justifyContent: "space-between",
  width: "100%",
  minWidth: "300px",
  maxWidth: "100%"
}))

const ContinueDialog = (props) => {
  const {
    title,
    message,
    onAddSubmit,
    setShowContinueModal,
    result,
    values,
    cancelBtnText,
    continueBtnText,
    isOpen = true,
    children = null
  } = props
  const { t } = useTranslation()
  const [open, setOpen] = useState(isOpen)
  const [dataResult, setDataResult] = useState(null)
  const handleClose = () => {
    result.status = 0
    setShowContinueModal(false)
  }

  const handleSubmit = () => {
    if (values) {
      onAddSubmit(values)
    } else {
      onAddSubmit()
    }
  }

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      aria-labelledby={title}
      aria-describedby={message}
      maxWidth="xs">
      <Grid container direction="column" alignItems="center">
        <DialogContent my={2}>
          {children ? (
            children
          ) : (
            <>
              <Typography align="center" variant="h4" paragraph>
                {title}
              </Typography>
              <Typography align="center" paragraph>
                {message}
              </Typography>
            </>
          )}
        </DialogContent>
        <StyledDialogActions>
          <Button onClick={handleClose} color="primary" variant="outlined">
            {cancelBtnText || t("global.close", "Close")}
          </Button>
          <ClpButton onClick={handleSubmit} color="primary" variant="contained" result={result}>
            {continueBtnText || t("global.buttons.complete", "Complete")}
          </ClpButton>
        </StyledDialogActions>
      </Grid>
    </Dialog>
  )
}

export default ContinueDialog
